/* Send the navigation question through the existing, single Ask Qoolala form. */
document.addEventListener('submit', event => {
  const nav = event.target.closest('[data-qc-nav-ask]');
  if (!nav) return;
  event.preventDefault();
  const source = nav.querySelector('input');
  const ask = document.querySelector('[data-qg-ask]');
  const form = ask?.querySelector('form');
  const input = form?.querySelector('input[name="message"]');
  if (!input || !form || !source.value.trim()) return;
  input.value = source.value.trim();
  ask.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  input.focus({ preventScroll: true });
  form.requestSubmit();
});

/* Scroll only the rail; no automatic advance or page movement. */
document.querySelectorAll('[data-qc-carousel]').forEach(section => {
  const track = section.querySelector('[data-qc-track]');
  const controls = section.querySelector('[data-qc-controls]');
  const previous = section.querySelector('[data-qc-prev]');
  const next = section.querySelector('[data-qc-next]');
  if (!track || !controls || !previous || !next) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const refresh = () => {
    const canScroll = track.scrollWidth > track.clientWidth + 2;
    controls.hidden = !canScroll;
    previous.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  };
  const move = direction => track.scrollBy({ left: direction * (track.querySelector('.qc-slide')?.getBoundingClientRect().width + 16 || track.clientWidth), behavior: reduced.matches ? 'auto' : 'smooth' });
  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  track.addEventListener('keydown', event => { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); } });
  track.addEventListener('scroll', refresh, { passive: true });
  window.addEventListener('resize', refresh, { passive: true });
  refresh();
});
/* A small movement on the decorative orbit, disabled for reduced motion. */
const qcOrbit = document.querySelector('.qc-hero-orbit');
const qcMotion = matchMedia('(prefers-reduced-motion: reduce)');
let qcFrame = 0;
function qcParallax() {
  qcFrame = 0;
  if (!qcOrbit) return;
  qcOrbit.style.transform = qcMotion.matches ? '' : `translateY(${Math.min(window.scrollY, 500) * .05}px)`;
}
window.addEventListener('scroll', () => { if (!qcFrame) qcFrame = requestAnimationFrame(qcParallax); }, { passive: true });
qcMotion.addEventListener('change', qcParallax);
qcParallax();
